export const SqlLoginMethod = Object.freeze({
	SqlLogin: 1,
	WindowsAuthentication: 2,
});
